export const NAME_TAGS = {
	vod: ['subtype', 'products_group_name', 'payment_models'],
	audio: ['subtype', 'products_group_name', 'payment_models'],
	liveEvents: ['products_group_name'],
	articles: ['products_group_name'],
	collections: ['external_ids'],
	banners: ['group']
};
